import styled from 'styled-components';

import {
  LAYOUT_CONTENTS_MAX_WIDTH,
  LAYOUT_HEADER_HEIGHT,
  LAYOUT_SIDE_PADDING,
  baseLayoutBounds,
} from 'approot/shared/layout/layout.styles';
import { rem } from 'approot/shared/style';
import { grey1, grey4 } from 'approot/shared/styles/colours.style';
import { CONTENT_PAGE_ACTION_BAR } from 'approot/shared/layout/layout.constants';
import { spacing16, spacing24 } from 'approot/shared/styles/spacing.style';
import { TabsTabStyled } from 'approot/shared/tabs/tabs.style';

export const ACTION_BAR_BREAKPOINT = 890;

type LessonActionBarProps = {
  bannerHeight?: number;
};
export const LessonActionBar = styled.div<LessonActionBarProps>`
  box-sizing: border-box;
  position: sticky;
  top: ${({ bannerHeight = 0 }) =>
    rem(LAYOUT_HEADER_HEIGHT - 1 + bannerHeight)};
  z-index: 5;
`;

export const LessonActionBarContent = styled.div.attrs({
  id: CONTENT_PAGE_ACTION_BAR,
  'data-selector': 'content-page-action-bar',
})`
  ${baseLayoutBounds}

  background-color: ${grey1};
  border-bottom: 1px solid ${grey4};
  display: flex;
  justify-content: space-between;
  max-width: ${rem(LAYOUT_CONTENTS_MAX_WIDTH + LAYOUT_SIDE_PADDING * 2)};
  margin: auto;
  overflow-y: hidden;
  overflow-x: auto;
  padding-top: ${rem(spacing16)};
  width: 100%;
`;

export const LessonActionBarGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(spacing16)};
  margin-bottom: ${rem(2)};
`;

export const LessonActionBarGroupWrapper = styled.div`
  ${baseLayoutBounds}

  max-width: ${rem(LAYOUT_CONTENTS_MAX_WIDTH + LAYOUT_SIDE_PADDING * 2)};
  margin: auto;
  padding-top:  ${rem(spacing16)};
  width: 100%;

  @media (min-width: ${ACTION_BAR_BREAKPOINT}px) {
    padding-top: 0;
  }
`;

export const LessonActionBarTabs = styled.div`
  width: 100%;

  ${TabsTabStyled} {
    margin-right: 0;
    min-width: ${rem(150)};
    white-space: nowrap;
  }

  @media (min-width: ${ACTION_BAR_BREAKPOINT}px) {
    width: auto;

    ${TabsTabStyled} {
      min-width: auto;
      margin-right: ${rem(spacing24)};
    }
  }
`;
